import { createSelector } from '@ngrx/store';

import { isOnlineMapped } from '../../../appSettings/selectors/isOnlineMapped/is-online-mapped.selector';
import { getPaymentErrorsMapped } from '../../../payment/selectors/getPaymentErrorsMapped/get-payment-errors-mapped.selector';
import { hasRecalculateFailedErrorMapped } from '../../../onlineOrder/selectors/hasRecalculateFailedErrorMapped/has-recalculate-failed-error-mapped.selector';
import { getCardsErrorsMapped } from '../../../creditCards/selectors/getCardsErrorsMapped/get-cards-errors-mapped.selector';

export const getOrderErrorsMapped = () =>
    createSelector(
        isOnlineMapped(),
        getPaymentErrorsMapped,
        hasRecalculateFailedErrorMapped,
        getCardsErrorsMapped,
        (offlineErrors, paymentErrors, onlineOrders, creditCardsErrors) => offlineErrors || paymentErrors || onlineOrders || creditCardsErrors,
    );
